const PRODUCT_CALCULATOR_RESOURCE = 'productcalculator';

const messageLabels = {
	noCorrectValues: 'noCorrectValues',
	noQuotes: 'noQuotes',
	premiumTooLow: 'premiumTooLow',
	stopLossReached: 'stopLossReached',
};

const createMessage = (messageKey) => {
	if (!messageLabels.hasOwnProperty(messageKey)) {
		return false;
	}

	const labelKey = messageLabels[messageKey];
	const resourceName = PRODUCT_CALCULATOR_RESOURCE;
	const resource = JSON.stringify({ labelKey, resourceName });

	const message = document.createElement('x-message');

	message.setAttribute('icon', 'warning');
	message.setAttribute('iconSize', 'm');
	message.setAttribute('modifier', 'warning');
	message.setAttribute('resource', resource);

	return message;
};

export default createMessage;
export { messageLabels };
